import { truncate } from '../../App';
export const Tablet = (props) => (
  <>
    <div className='compare_cont'>
      <div className='contents onlyweb' id='hide'>
        <div
          className='purple'
          style={{
            height: 'inherit'
            // background: "red",
            // transform: "translateY(200px)",
            // display: "block",
            // paddingTop: "10px",
          }}>
          <div
            className='in_purple_div'
            style={{
              width: '100%',
              // height: "85%",
              // height: "inherit",
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'column'
            }}>
            <div
              className='info'
              id='info'
              style={{
                height: '150px'
              }}>
              Name
            </div>
            <div className='info' id='info'>
              Flipkart Price
            </div>
            {/* <div className="info" id="info">
            Price
          </div> */}
            <div className='info' id='info'>
              Amazon Price
            </div>
            <div className='info' id='info'>
              Ratings
            </div>
            {props.data1.specs.map((spec) => {
              return (
                <div className='info' id='info'>
                  {spec[0]}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className='contents '>
        <div className='comp_pic'>
          <img src={props.coverimage1} alt={props.data1.title}></img>
          <div>
            <p>{truncate(props.data1.title, 25)}</p>
            <div className='onlymobile'>
              <div className='crating'>
                <span>
                  {props.data1.rating} <p>*</p>
                </span>
                <div>{props.data1.ratingsNums} Ratings </div>
              </div>
            </div>
          </div>
          {/* <p>{props.data1.Name}</p> */}
          <div className='pr onlyweb'>{props.data1.price}</div>
        </div>
        <div
          className='purple1 onlyweb'
          // style={{
          //   height: "1200px",
          //     background: "transparent",
          //   paddingTop: "80px",
          //   transform: "translateY(-235px)",
          // }}
        >
          <div
            style={{
              width: '100%',
              // height: "85%",
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'column'
              // background: "transparent",
            }}>
            <div
              className='info info1'
              id='info'
              style={{
                height: '150px'
              }}>
              {props.data1.title == ''
                ? '-'
                : props.data1.title.slice(0, 100) + '...'}
            </div>
            {/* <div className="info info1" id="info">
            {props.data1.Price == "" ? "-" : props.data1.Price}
          </div> */}
            <div className='info info1' id='info'>
              {props.data1.price === '' ? '-' : props.data1.price}
            </div>
            {/* <div className="info info1" id="info">
            {props.data1.Price === "" ? "-" : props.data1.Price}
          </div> */}
            <div className='info info1' id='info'>
              {props.data1.amazonPrice == '' ||
              props.data1.amazonPrice == '₹undefined'
                ? 'NOT FOUND'
                : props.data1.amazonPrice}
            </div>
            <div className='info info1' id='info'>
              {props.data1.rating == '' ? '-' : props.data1.rating}
            </div>

            {props.data1.specs.map((data, i) => {
              return (
                <div className='info info1' id='info'>
                  {data[1] === '' ? '-' : data[1]}
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className='vs onlymobile'>VS</div>
      <div className='contents '>
        <div className='comp_pic'>
          <img src={props.coverimage2} alt={props.data2.title}></img>
          <div>
            <p>{truncate(props.data2.title, 25)}</p>
            <div className='onlymobile'>
              <div className='crating'>
                <span>
                  {props.data2.rating} <p>*</p>
                </span>
                <div>{props.data2.ratingsNums} Ratings </div>
              </div>
            </div>
          </div>
          <div className='pr onlyweb'>{props.data2.price}</div>
        </div>
        <div
          className='purple2 onlyweb'
          // style={{
          //   height: "1200px",
          //   paddingTop: "80px",
          //   transform: "translateY(-235px)",
          // }}
        >
          <div
            style={{
              width: '100%',
              height: '85%',
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'column'
            }}>
            <div
              className='info info1'
              id='info'
              style={{
                height: '150px'
              }}>
              {props.data2.title === ''
                ? '-'
                : props.data2.title.slice(0, 100) + '...'}
            </div>
            <div className='info info1' id='info'>
              {props.data2.price === '' ? '-' : props.data2.price}
            </div>
            {/* <div className="info info1" id="info">
            {props.data2.Price == "" ? "-" : props.data2.Price}
          </div> */}
            <div className='info info1' id='info'>
              {props.data2.amazonPrice == '' ? '-' : props.data2.amazonPrice}
            </div>
            <div className='info info1' id='info'>
              {props.data2.rating == '' ? '-' : props.data2.rating}
            </div>
            {props.data2.specs.map((data, i) => {
              return (
                <div className='info info1' id='info'>
                  {data[1] === '' ? '-' : data[1]}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  </>
);
